import { signOut } from "next-auth/react"
import styles from "../../styles/ProfileMenu.module.css"
import {
  Avatar,
  Button,
  CircularProgress,
  IconButton,
  Paper,
  Tooltip,
} from "@mui/material"
import { UserInfo } from "../../helpers/customHooks/useUserInfo"
import CloseIcon from "@mui/icons-material/Close"
import { Dispatch, SetStateAction, useState } from "react"
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp"
import LogoutIcon from "@mui/icons-material/Logout"
import LockOutlinedIcon from "@mui/icons-material/LockOutlined"
import ControlPointOutlinedIcon from "@mui/icons-material/ControlPointOutlined"

interface ProfileMenuProps {
  isOpen: boolean
  setIsOpen: Dispatch<SetStateAction<boolean>>
  userInfo: UserInfo | null
}

export default function ProfileMenu({
  isOpen,
  setIsOpen,
  userInfo,
}: ProfileMenuProps) {
  if (!isOpen) return <></>
  return (
    <Paper elevation={3} className={styles.container}>
      <div className={styles.innerContainer}>
        {!userInfo && <CircularProgress />}
        {userInfo && (
          <>
            <div className={styles.closeButton}>
              <IconButton
                aria-label="close"
                size="medium"
                onClick={() => setIsOpen(false)}
              >
                <CloseIcon fontSize="inherit" />
              </IconButton>
            </div>
            <span className={styles.titleMinor}>{userInfo.email}</span>
            <Avatar
              alt={userInfo?.name}
              src={userInfo?.picture}
              sx={{ width: 64, height: 64 }}
            />
            <span
              className={styles.welcomeMessage}
            >{`Hallo ${userInfo.name}!`}</span>

            <AccountsAccordion userInfo={userInfo} />
            <div>
              <Button color="secondary" size="small" disabled>
                Data privacy policy
              </Button>
            </div>
          </>
        )}
      </div>
    </Paper>
  )
}

function AccountsAccordion({ userInfo }: { userInfo: UserInfo }) {
  const [isExpanded, setIsExpanded] = useState(true)
  return (
    <div
      className={`${styles.accordionContainer} ${
        isExpanded ? "" : styles.collapsed
      }`}
    >
      <div
        className={`${styles.accordionHeader} ${styles.accordionItemCommon}`}
        onClick={() => setIsExpanded(!isExpanded)}
      >
        <span className={styles.titleMinor}>Connected Accounts</span>
        <div className={styles.headerIcons}>
          <div className={styles.counterIcon}>
            <span>{1}</span>
          </div>
          <div className={styles.expandIcon}>
            <KeyboardArrowUpIcon fontSize={"small"} />
          </div>
        </div>
      </div>
      <div
        className={`${styles.accordionItem} ${styles.accordionItemCommon} ${styles.itemDisabled}`}
      >
        <div className={styles.accountContainer}>
          <Avatar
            alt={userInfo?.name}
            src={userInfo?.picture}
            sx={{ width: 32, height: 32 }}
          />
          <div className={styles.accountNamesContainer}>
            <span className={styles.titleMinor}>{userInfo?.name}</span>
            <span className={styles.accountNameId}>{userInfo?.email}</span>
          </div>
        </div>
        <div className={styles.normalIcon}>
          <Tooltip title="This account can't be unlinked. Please connect another account first.">
            <LockOutlinedIcon fontSize={"small"} />
          </Tooltip>
        </div>
      </div>
      <div
        className={`${styles.accordionItem} ${styles.accordionItemCommon} ${styles.itemDisabled}`}
      >
        <Tooltip title="This function is not supported yet.">
          <div className={styles.itemContainerLeftAligned}>
            <div className={styles.leftIcon}>
              <ControlPointOutlinedIcon fontSize={"small"} />
            </div>
            <span className={styles.titleMinor}>Connect another account</span>
          </div>
        </Tooltip>
      </div>
      <div
        className={`${styles.accordionFooterDetached} ${styles.accordionItemCommon}`}
        onClick={() => signOut()}
      >
        <div className={styles.itemContainerLeftAligned}>
          <div className={styles.leftIcon}>
            <LogoutIcon fontSize={"small"} />
          </div>
          <span className={styles.titleMinor}>Log out</span>
        </div>
      </div>
    </div>
  )
}
